var exports = {
  "ZA": "xf0b3b88a--05af2c--suggest",
  "rg": "xf0b3b88a--05af2c--suggest-item",
  "e5": "xf0b3b88a--05af2c--suggest-error",
};

module.exports = exports;
